import { ScriptDef, ScriptTheme } from '../../types';

export const TV_JUNLV_SCRIPTS: ScriptDef[] = [
    {
        id: 'SCRIPT_137',  // 电视剧/基层军旅成长·版本一
        name: '长线',
        genre: 'tv',
        synopsis: '新兵秦笑在队列会操上把齐步走成了正步，被分到全团最偏远的通信连，靠把接线、守台这些枯燥的活做到极致，一步步长成了报务骨干。五十年一遇的洪灾里，她背着电台在泥水里守了三天三夜，抢通最后一条生命线，带她上路的班长却倒在了洪堤上。多年后，秦笑守着那台被泥水泡过的旧电台带兵，把那根长线一代代传了下去。',
        roles: [
            {
                name: '秦笑',
                roleType: '女主角',
                billing: 1,
                intro: '通信连列兵，笨，认死理，能对着一块电台面板坐一整天。别人嫌枯燥的接线练习她做得最细，全连哪个班哪台电台什么频率，她都记得。班长倒下后，她接过了那台被泥水泡过的旧电台，也接过了班长手里的兵。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'stamina', value: 50 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, temperament: 3, stamina: 2, wisdom: 2 },
            },
            {
                name: '沈岸',
                roleType: '女二号',
                billing: 2,
                intro: '通信连班长，三期士官，带新兵带了十几年，团里点名都想不起她。年轻时在比武场上出过一次差错被调离一线，从此只管训练不管人。秦笑是第一个管她叫"师傅"而不是"班长"的兵，也是她在洪堤上替着扛开倒杆的那一个。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 40 },
                    { attr: 'talent', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 6,
                attributeGrowth: { temperament: 2, talent: 2, wisdom: 2 },
            },
            {
                name: '聂小舟',
                roleType: '女配角',
                billing: 4,
                intro: '秦笑的同乡同年兵，通信连报务骨干，样样比秦笑快一步。旅特战大队选拔她止步四百米障碍，回连队后照样是训练标兵。抗洪那一夜，是她和秦笑背靠背守到了天亮。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'stamina', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 2,
                attributeGrowth: { stamina: 3, talent: 2 },
            },
            {
                name: '周冬',
                roleType: '男配角',
                billing: 5,
                intro: '通信连的义务兵，管机房卫生和设备搬运，一天到晚擦机器、盘线缆，话没几句。秦笑守台的三天三夜，是他一趟趟往堤上送电池和干粮。',
                level: 2,
                gender: 'male',
                requirements: [
                    { attr: 'stamina', value: 12 },
                ],
                shootWeeks: 1,
                attributeGrowth: { stamina: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Military, ScriptTheme.SeriousDrama],
        heat: 55,
        baseScore: 8.7,
    },
    {
        id: 'SCRIPT_138',  // 电视剧/基层军旅成长·版本二
        name: '洼地',
        genre: 'tv',
        synopsis: '1948年冬，济南战役后，一批被俘的国民党军士兵经诉苦教育后补入解放军连队，人称"解放战士"。机枪手崔大漏、军医助理齐半仙、伙夫佟满仓被编进同一个排，起初谁也不服谁：有人惦记家里的地，有人惦记老部队的饷，有人惦记活着回去。指导员洪铁不训话，只让他们轮流讲自己的家史。徐州方向的炮声近了，这个排被顶在黄泛区一段洼地阻援。',
        roles: [
            {
                name: '崔大漏',
                roleType: '男主角',
                billing: 1,
                intro: '原国民党军整编师机枪手，枪打得准，话茬子更准，进解放区头一个月就想跑。他那挺打坏的水冷机枪，别人修不好，他拆了装、装了拆，三天就让它重新上了阵地。',
                level: 8,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 80 },
                    { attr: 'temperament', value: 70 },
                    { attr: 'wisdom', value: 65 },
                    { attr: 'stamina', value: 55 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 4, temperament: 3, wisdom: 3, stamina: 3 },
            },
            {
                name: '齐半仙',
                roleType: '男二号',
                billing: 2,
                intro: '原军医助理，半路出家，包扎全凭胆大，什么伤都敢上手。两副夹板他随身带着，救过解放军的兵，也救过老部队的兵。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2, charm: 2 },
            },
            {
                name: '佟满仓',
                roleType: '男配角',
                billing: 2,
                intro: '原伙夫，围了两年城，会做八种杂粮饼子，什么粮食到他手里都能做出饭味。他跟炮弹皮抢过三口行军锅，锅都瘪了，饭一顿没断。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'stamina', value: 50 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 3, temperament: 3, stamina: 2, wisdom: 2 },
            },
            {
                name: '洪铁',
                roleType: '男配角',
                billing: 3,
                intro: '连队指导员，诉苦教育课上从不念稿子。解放战士家里还有什么人、在什么地方，他都记在自己的本子上。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '蔡兰英',
                roleType: '女配角',
                billing: 4,
                intro: '纵队卫生队的看护，慰问演出唱两句，全排喊她"小百灵"。洼地那三天，齐半仙在前头包扎，她跟着担架一路往后送，仗打完再没人喊过这个外号。',
                level: 3,
                gender: 'female',
                requirements: [
                    { attr: 'artistry', value: 18 },
                    { attr: 'stamina', value: 15 },
                ],
                shootWeeks: 2,
                attributeGrowth: { artistry: 2, stamina: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Military, ScriptTheme.War, ScriptTheme.SeriousDrama],
        heat: 52,
        baseScore: 8.3,
    },
    {
        id: 'SCRIPT_139',  // 电视剧/基层军旅成长·版本三
        name: '尖兵出鞘',
        genre: 'tv',
        synopsis: '新组建的特战旅面向全旅遴选首批"尖兵集训队"，规定各连只报一人。摩步连上等兵程飞凭五公里武装越野全旅第一入选，集训队队长金砺对其格外看重。集训全程设体能、射击、伞降、侦察四关，每关末位淘汰。程飞屡次在关键考核中以极限状态胜出，并在综合演练中独力完成敌后引导任务，获评"全旅尖兵"。结业典礼上，程飞作为全体学员代表发言，宣布下一目标：代表全旅出征国际特种兵比武。',
        roles: [
            {
                name: '程飞',
                roleType: '男主角',
                billing: 1,
                intro: '摩步连上等兵，五公里、四百米障碍、射击三项全旅第一，入伍两年零受伤记录。他有个习惯，每次考核前默念一遍自己的名字，然后第一名就是他的。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'stamina', value: 60 },
                    { attr: 'talent', value: 55 },
                    { attr: 'temperament', value: 50 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { stamina: 3, talent: 3, temperament: 2, wisdom: 2 },
            },
            {
                name: '金砺',
                roleType: '男二号',
                billing: 2,
                intro: '特战旅副参谋长兼集训队队长，阅人无数，看人只看三秒。他断言程飞是十年一遇的好苗子，集训期间为其单独调整了三套训练方案。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 50 },
                    { attr: 'talent', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { temperament: 3, talent: 3, wisdom: 2 },
            },
            {
                name: '白书宁',
                roleType: '女配角',
                billing: 2,
                intro: '旅卫生队军医，负责集训队医疗保障。她为程飞建立的体能档案被全队推广，档案封面签了一行字：此人免检。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 50 },
                    { attr: 'talent', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { temperament: 3, talent: 3, wisdom: 2 },
            },
            {
                name: '侯赛',
                roleType: '男配角',
                billing: 2,
                intro: '侦察连班长，程飞在集训队最大的竞争对手。输给程飞的当天，他总会交一份新的训练计划，赛前公开表示：输给程飞不丢人。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'stamina', value: 40 },
                    { attr: 'talent', value: 35 },
                    { attr: 'temperament', value: 30 },
                ],
                shootWeeks: 6,
                attributeGrowth: { stamina: 2, talent: 2, temperament: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Military, ScriptTheme.Action],
        heat: 36,
        baseScore: 5.4,
    },
    {
        id: 'SCRIPT_140',  // 电视剧/宏大革命战争史诗·版本一
        name: '首渡',
        genre: 'tv',
        synopsis: '1949年4月，国民党军凭借长江天险布下江防，和谈的烟幕下兵力正在南调。第三野战军选派先遣渡江大队，于总攻前十天乘夜潜入江南，摸清敌江防部署、接应主力登陆。三野某军侦察科长谢屏舟带队偷渡成功，与皖南地下交通员接上头，把南岸炮位、雷区、哨所换防的底册一份份往北送。4月20日夜，百万雄师中的突击集团率先发起渡江，木船扬帆冲向南岸，先遣大队按事先约定，在敌纵深点起了三堆火。',
        roles: [
            {
                name: '谢屏舟',
                roleType: '男主角',
                billing: 1,
                intro: '第三野战军某军侦察科长，先遣渡江大队大队长，泅渡、侦绘样样在行，皖南话都说得地道。他带队在江南敌后走了七天，把南岸的江防部署摸清了大半。',
                level: 8,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 80 },
                    { attr: 'temperament', value: 70 },
                    { attr: 'wisdom', value: 65 },
                    { attr: 'stamina', value: 55 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 4, temperament: 3, wisdom: 3, stamina: 3 },
            },
            {
                name: '秦月汀',
                roleType: '女主角',
                billing: 1,
                intro: '皖南沿江地下党交通员，以镇上小学代课教员的身份往来于哨卡与市镇之间。沿江各哨卡的换防时间她都记得，情报从她手上过江，从没出过差错。',
                level: 8,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 80 },
                    { attr: 'temperament', value: 70 },
                    { attr: 'wisdom', value: 65 },
                    { attr: 'charm', value: 55 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 4, temperament: 3, wisdom: 3, charm: 3 },
            },
            {
                name: '苗长青',
                roleType: '男二号',
                billing: 2,
                intro: '江北船工总队长，祖上三代跑长江水路。他动员了自家两条船打头阵，大儿子掌舵，父子俩都在第一批渡江的船队里。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'stamina', value: 50 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 3, temperament: 3, stamina: 2, wisdom: 2 },
            },
            {
                name: '陈二艄',
                roleType: '男配角',
                billing: 5,
                intro: '江北船工，苗长青手下的年轻舵手，渡江前刚学会认风向，一趟趟往南岸送人。',
                level: 3,
                gender: 'male',
                requirements: [
                    { attr: 'stamina', value: 18 },
                    { attr: 'wisdom', value: 15 },
                ],
                shootWeeks: 1,
                attributeGrowth: { stamina: 2, wisdom: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.War, ScriptTheme.History, ScriptTheme.SeriousDrama],
        heat: 55,
        baseScore: 8.8,
    },
    {
        id: 'SCRIPT_141',  // 电视剧/宏大革命战争史诗·版本二
        name: '江桥',
        genre: 'tv',
        synopsis: '1951年秋，志愿军秋季攻势在即，前线弹药告急，而清川江上的铁路大桥在头夜轰炸中被炸开一个大洞。志愿军铁道兵团某团奉命抢修，团长梁又青立下军令状：七天通夜行车。白天美军飞机盘旋，工程只能挪到夜里，江面上冰排撞着桥墩响。对岸把这个桥段标成每日必炸目标，炸了修，修了炸，七天里桥面没有一处是完整的。',
        roles: [
            {
                name: '梁又青',
                roleType: '男主角',
                billing: 1,
                intro: '志愿军铁道兵团某团团长，铁路工程出身，抢险时自己先上桥。全桥的钢梁编号他都记得，哪几根承不住重载，他闭着眼能报出来。',
                level: 8,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 80 },
                    { attr: 'temperament', value: 70 },
                    { attr: 'wisdom', value: 65 },
                    { attr: 'stamina', value: 55 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 4, temperament: 3, wisdom: 3, stamina: 3 },
            },
            {
                name: '沈屿',
                roleType: '女主角',
                billing: 1,
                intro: '随军气象员兼译电员，每天摸黑爬瞭望架记录风速水情。她按气温曲线挑出冰排最脆、撞墩最狠的那几个时辰，让工程队错开它们开工。',
                level: 8,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 80 },
                    { attr: 'temperament', value: 70 },
                    { attr: 'wisdom', value: 65 },
                    { attr: 'stamina', value: 55 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 4, temperament: 3, wisdom: 3, stamina: 3 },
            },
            {
                name: '隋拙',
                roleType: '男二号',
                billing: 2,
                intro: '守桥高炮阵地指挥员，打完这一仗就该复员的老兵。他给每门炮的炮位垫了三层枕木，说炮身稳一分，桥就多一分。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2, charm: 2 },
            },
            {
                name: '裴孟白',
                roleType: '男配角',
                billing: 2,
                intro: '美军远东空军侦察机中队军官，负责这个桥段的每日航拍，照片在办公室里贴满一面墙。桥炸塌几次又修好几次，他看得比谁都清楚，可他每次上报"桥已瘫痪"，下一周的照片上列车照样在夜里过江。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2, charm: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.War, ScriptTheme.History, ScriptTheme.SeriousDrama],
        heat: 54,
        baseScore: 8.6,
    },
    {
        id: 'SCRIPT_142',  // 电视剧/宏大革命战争史诗·版本三
        name: '雪原纵深',
        genre: 'tv',
        synopsis: '1950年11月，志愿军第九兵团秘密入朝，在长津湖地区零下三十度的雪原上隐蔽开进，围歼美军陆战一师。某师先遣团团长关云骢的部队白天伏卧雪窝、夜里冒雪行军，冻伤减员很快超出一成。兵团部对"打不打得动"出现两种意见，军长侯之柏把一线冻伤报告原样上报，同时按总攻命令把穿插路线再压进敌纵深二十里。总攻当夜，穿插部队准时出现在水门桥至黄草岭一线的山脊上，切断了美军后撤公路的咽喉。',
        roles: [
            {
                name: '关云骢',
                roleType: '男主角',
                billing: 1,
                intro: '第九兵团某师先遣团团长，全军最年轻的团职干部，军校毕业不足四年。他把全团冻伤员名单按营装订成册，附页上手写了一页行军改进办法。',
                level: 8,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 80 },
                    { attr: 'temperament', value: 70 },
                    { attr: 'wisdom', value: 65 },
                    { attr: 'stamina', value: 55 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 4, temperament: 3, wisdom: 3, stamina: 3 },
            },
            {
                name: '侯之柏',
                roleType: '男二号',
                billing: 2,
                intro: '第九兵团某军军长，老红军出身，决策前必听两种相反的意见。一线的冻伤报告他原样往上报，不删一个数字。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2, charm: 2 },
            },
            {
                name: '虞九',
                roleType: '女配角',
                billing: 2,
                intro: '兵团部卫生队女军医，随先遣团行动。她在零下三十度里摸索出一套冻伤处置顺序，那份用铅笔写在炮弹药箱纸板上的流程，后来被推广到全线。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2, charm: 2 },
            },
            {
                name: '傅其相',
                roleType: '男配角',
                billing: 2,
                intro: '美军陆战一师某团作战军官，把防御重点摆在公路正面，侧翼只留了警戒哨。他对志愿军能在这样的天气里长途穿插没有概念。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2, charm: 2 },
            },
            {
                name: '石头',
                roleType: '男配角',
                billing: 5,
                intro: '先遣团的通信员，夜里在各营之间送信，一趟来回二十里，鞋早就冻硬了。',
                level: 3,
                gender: 'male',
                requirements: [
                    { attr: 'stamina', value: 18 },
                    { attr: 'wisdom', value: 15 },
                ],
                shootWeeks: 1,
                attributeGrowth: { stamina: 2, wisdom: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.War, ScriptTheme.History, ScriptTheme.SeriousDrama],
        heat: 53,
        baseScore: 8.4,
    },
    {
        id: 'SCRIPT_143',  // 电视剧/年代军旅家庭·版本一
        name: '军功章',
        genre: 'tv',
        synopsis: '1952年，三十八岁的团长章铁犁随部队进驻南川市，在全军英模大会上见到了纺织厂的劳动模范阎秀禾。打了半辈子仗的人不会谈恋爱，警卫员替他往纺织厂提亲，两家人吃了几顿饭，第二个月就把婚事办了。婚后一个按操典过日子，一个按厂规过日子，谁也改编不了谁。此后几十年，部队调防，几个孩子陆续长大，这个家为参军、为下乡、为改革开放后孩子下海经商，吵过无数回架。章铁犁那枚军功章锁了几十年，直到孙辈当兵那天才开盒。',
        roles: [
            {
                name: '章铁犁',
                roleType: '男主角',
                billing: 1,
                intro: '某步兵团团长，十三岁参军，身上留有三处弹片。他把家管成连队，点名、内务、紧急集合一样不落，孩子们背地里叫他"章连长"。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2, charm: 2 },
            },
            {
                name: '阎秀禾',
                roleType: '女主角',
                billing: 1,
                intro: '纺织厂挡车工，市劳动模范，嫁人那天刚评上先进。她一手好裁缝，几十年里给全楼的人做过衣裳，自己的衣裳永远是那几件旧的。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2, charm: 2 },
            },
            {
                name: '贺松',
                roleType: '男二号',
                billing: 2,
                intro: '章铁犁的老政委，两家住一个院。他是这个家的和事佬，也是唯一敢当面数落章铁犁的人，数落完两人必喝一顿。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 2, temperament: 2, wisdom: 2 },
            },
            {
                name: '祝棠',
                roleType: '女配角',
                billing: 3,
                intro: '章家大女儿，从小不服父亲的管教，改革开放后第一批辞职下海。她的辞职报告在饭桌上被父亲压了三个月，最后还是她自己拿走交了上去。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 4,
                attributeGrowth: { charm: 3, talent: 2 },
            },
            {
                name: '小崔',
                roleType: '男配角',
                billing: 5,
                intro: '章铁犁的警卫员，跟着首长调防三次，替首长往纺织厂跑过提亲那趟腿，平时管接送和收发。',
                level: 2,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 12 },
                ],
                shootWeeks: 1,
                attributeGrowth: { temperament: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Period, ScriptTheme.Military],
        heat: 54,
        baseScore: 9.1,
    },
    {
        id: 'SCRIPT_144',  // 电视剧/年代军旅家庭·版本二
        name: '门诊部的灯',
        genre: 'tv',
        synopsis: '1980年，南川军区总医院门诊部，护士聂海燕刚转正，摆在她面前的是两条路：考军医大学，或是家里托人介绍的稳妥对象。军马所技术员齐天佐常往门诊部跑，木匠活儿全院第一，追聂海燕追得全院皆知，追法是替病区把所有松掉的椅子腿钉了一遍。她在《解放军报》上读到边防排长岳树声的一篇读者来信，一来二去成了笔友，两年没见过一面。之后的十年，裁军、下海、出国潮一波波打过来，有人脱了军装先富了起来，有人把药瓶拧到了最后。',
        roles: [
            {
                name: '聂海燕',
                roleType: '女主角',
                billing: 1,
                intro: '门诊部护士，手稳，记性差，差在人情往来，好在药名从不出错。转正后她一边值夜班一边备考军医大学，两年里没歇过一个完整的周末。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2, charm: 2 },
            },
            {
                name: '齐天佐',
                roleType: '男配角',
                billing: 2,
                intro: '军马所技术员，全院孩子的木匠，谁家椅子板凳坏了都找他。他追聂海燕的方式不声不响，全病区摇了十年的椅子都被他钉过一遍。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 50 },
                    { attr: 'talent', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { temperament: 3, talent: 3, wisdom: 2 },
            },
            {
                name: '岳树声',
                roleType: '男配角',
                billing: 3,
                intro: '边防排长，聂海燕的笔友，话少，信里从没写过立功的事。两年里两人只通信没见过面，他一直以为对方是个男的。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 40 },
                    { attr: 'talent', value: 35 },
                    { attr: 'stamina', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { temperament: 2, talent: 2, stamina: 2 },
            },
            {
                name: '蒲柳',
                roleType: '女配角',
                billing: 3,
                intro: '同病区的卫生员，聂海燕的同铺，第一批脱下军装南下卖医疗器械的人。临走留给聂海燕一只听诊器，说白大褂得有人接着穿。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 2, temperament: 2, wisdom: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Period, ScriptTheme.Military],
        heat: 52,
        baseScore: 8.7,
    },
    {
        id: 'SCRIPT_145',  // 电视剧/年代军旅家庭·版本三
        name: '三线家属院',
        genre: 'tv',
        synopsis: '1969年，为备战需要，某军械修配厂整体迁入西南山区，代号"537厂"。军代表郑向东带着妻子方亚男和两个孩子在山沟里安了家，家属院里住着技术员、转业兵、随迁工人，一个院就是一个小社会。工厂为部队修枪修炮二十年，九十年代军品订单锐减，转产民品，一半人下岗分流。方亚男带头组织家属缝纫组，把院里下岗的女工一个个拢了起来。厂子改制挂牌那天，老厂长把"537"的门牌摘下来，交给了厂史馆。',
        roles: [
            {
                name: '郑向东',
                roleType: '男主角',
                billing: 1,
                intro: '军械修配厂军代表，工程师出身，一根游标卡尺用了半辈子。他在山里修了二十年枪，最骄傲的不是修好多少支，是没出过一次事故。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2, charm: 2 },
            },
            {
                name: '方亚男',
                roleType: '女主角',
                billing: 1,
                intro: '随军家属，进厂当过检验工、食堂帮厨，最后自学的裁缝。家属院的第一台缝纫机是她的陪嫁，后来下岗的女工都聚到她这台机器边上做活。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2, charm: 2 },
            },
            {
                name: '简筠',
                roleType: '女配角',
                billing: 3,
                intro: '技术员，全厂第一个考出工程师职称的女性，郑向东的徒弟。九十年代她停薪留职去了沿海，是全厂第一个走出去的技术员。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 30 },
                    { attr: 'temperament', value: 25 },
                ],
                shootWeeks: 4,
                attributeGrowth: { charm: 3, temperament: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Period, ScriptTheme.Military],
        heat: 49,
        baseScore: 8.3,
    },
];
